import React, { memo } from 'react';
import sanitizeHtml from 'sanitize-html';

import { AttachmentResponse } from 'utils/api/inbox';
import { materialDownloadApi } from 'utils/api/attachments';

import DetailsTitle from 'components/DetailsTitle';
import Attachments from 'components/Attachments';
import Hr from 'components/Hr';
import Rating from 'components/Rating';

import { Container, TextData, Title, TitleRow } from './styles';

interface NoticesProps {
  name: string;
  title: string;
  content: string;
  attachments: AttachmentResponse[];
  violenceId?: number;
  isRating?: boolean;
  noticeId?: number;
  headerAction?: React.ReactNode;
}

const NoticeContent: React.FC<NoticesProps> = ({
  name,
  title,
  content,
  attachments,
  isRating,
  noticeId,
  headerAction,
}) => {
  const cleanHTML = sanitizeHtml(content, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['h1', 'h2', 'img', 'span', 'a']),
    allowedAttributes: {
      '*': ['style'],
      img: ['src', 'alt', 'width', 'height'],
      a: ['href', 'title', 'target'],
    },
  });

  return (
    <Container>
      <TextData>
        <TitleRow>
          <DetailsTitle title={name} />
          {headerAction}
        </TitleRow>
        <Title title={title} />
        <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
        {isRating && noticeId ? (
          <>
            <Hr />
            <Rating noticeId={noticeId} />
          </>
        ) : null}
        {!!attachments?.length && (
          <>
            <Hr />
            <Attachments
              attachments={attachments}
              noticeId={noticeId}
              downloadAttachment={materialDownloadApi.downloadAttachment}
              downloadAttachmentsZip={materialDownloadApi.downloadAttachmentsZip}
            />
          </>
        )}
      </TextData>
    </Container>
  );
};

export default memo(NoticeContent);
